// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundle_bundles__K5xd3"};